import React from 'react';
import classNames from 'classnames';
import DialogContent from '@material-ui/core/DialogContent';
import {withStyles} from '@material-ui/core/styles';

const styles = ({
  content: {
    maxWidth: 500,
    padding: 20,
    paddingLeft: 45,
    paddingRight: 45,
    margin: 0,
    boxSizing: 'border-box'
  }
});

const SimpleDialogContent = ({ classes,
                              children,
                              className,
                              ...other }) => {
  return (
    <DialogContent className={classNames(classes.content, className)}
                   {...other} >
      {children}
    </DialogContent>
  );
};

export default withStyles(styles)(
  SimpleDialogContent
);